document.addEventListener("change", (event) => {
    const input = event.target.closest?.('.gfield--type-fileupload input[type="file"]');
    if (!input) return;

    const field = input.closest(".gfield");
    const label = field?.querySelector(".gfield_label");
    if (!label) return;

    const textNode = [...label.childNodes].find((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
    if (!textNode) return;

    label.dataset.original ??= textNode.textContent;

    const name = input.files?.[0]?.name;
    textNode.textContent = name || label.dataset.original;
    field.classList.toggle("has-file", Boolean(name));
});
